<div
  *ngIf="conditions"
  class="scroll-guide"
>
  {{ 'misc.scroll_for_more' | translate }}
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/scroll-guide/scroll-guide.component.html